import { Suspense, type ReactNode } from "react"

import { AppHeader } from "@/components/marketplace/layout/app-header"
import { DesktopNav } from "@/components/marketplace/layout/desktop-nav"
import { MobileChrome } from "@/components/marketplace/layout/mobile-chrome"
import { MobileNav } from "@/components/marketplace/layout/mobile-nav"
import { MobileSearchProvider } from "@/components/marketplace/layout/mobile-search-state"
import type { FacetOption } from "@/components/marketplace/listing/types"
import type { NavCategory } from "@/components/marketplace/types"
import { HydrateAtViewport } from "@/components/ui/hydrate-at-viewport"

interface AppNavProps {
  categories: NavCategory[]
  searchCategoryOptions?: FacetOption[]
  bottomNav?: boolean
  desktopAccount?: ReactNode
  mobileAccount?: ReactNode
}

export const AppNav = ({ categories, searchCategoryOptions, bottomNav = false, desktopAccount, mobileAccount }: AppNavProps) => (
  <MobileSearchProvider>
    <div data-top-bar="" className="lg:hidden">
      {bottomNav ? <MobileNav account={mobileAccount} /> : <AppHeader categories={categories} searchCategoryOptions={searchCategoryOptions} />}
    </div>
    <div data-top-bar="" className="hidden lg:block">
      {/* The desktop bar can stream in after the first paint, so its fallback holds the bar's
          full height. A null fallback left the header 0px tall until then, and the whole page
          dropped 152px when the bar landed. */}
      <Suspense fallback={<div aria-hidden className="bg-surface border-line-subtle h-chrome-wide border-b" />}>
        <HydrateAtViewport query="(min-width: 1024px)">
          <DesktopNav categories={categories} account={desktopAccount} />
        </HydrateAtViewport>
      </Suspense>
    </div>
    {bottomNav && <MobileChrome categories={categories} />}
  </MobileSearchProvider>
)
